import { getMenu } from "@/components/layout/Navbar/api";

export const getMenuData = async () => {
  try {
    const res = await getMenu();
    if (!!res?.menus?.length) {
      const { menus } = res;
      if (menus && menus?.length === 1 && !!menus[0]) {
        return menus[0]?.sub_menus;
      }
      return menus;
    }
    return [];
  } catch (e) {
    return [];
  }
};

export const menuIcons = {
  setting: { viewBox: "0 0 18 17" },
  document: { viewBox: "0 0 18 17" },
  chart: { viewBox: "0 0 18 17" },
  paper: { viewBox: "0 0 18 17" },
  home: { viewBox: "0 0 18 17" },
  money: { viewBox: "0 0 18 17" },
  book: { viewBox: "0 0 18 17" },
  payment: { viewBox: "0 0 18 17" },
  notepad: { viewBox: "0 0 18 17" },
  calendar: { viewBox: "0 0 18 17" },
  box_arrow: { viewBox: "0 0 18 17" },
  trending: { viewBox: "0 0 18 17" },
  box: { viewBox: "0 0 18 17" },
  building: { viewBox: "0 0 18 17" },
  calendar_star: { viewBox: "0 0 18 17" },
  data: { viewBox: "0 0 18 17" },
  document_track: { viewBox: "0 0 18 17" },
  folder: { viewBox: "0 0 18 17" },
  mail_plus: { viewBox: "0 0 18 17" },
  content_view: { viewBox: "0 0 20 20" },
  people_team: { viewBox: "0 0 20 20" },
  mail: { viewBox: "0 0 20 20" },
  image_multiple: { viewBox: "0 0 20 20" },
};

export const searchMenuByName = (data, query) => {
  const lowerQuery = query.toLowerCase();

  const recursiveSearch = (items) => {
    return items
      .map((item) => {
        const matches = item.menu_name.toLowerCase().includes(lowerQuery);
        const filteredSubMenus = item.sub_menus
          ? recursiveSearch(item.sub_menus)
          : [];

        if (matches || filteredSubMenus.length > 0) {
          return {
            ...item,
            sub_menus: filteredSubMenus,
          };
        }
        return null;
      })
      .filter(Boolean);
  };

  return recursiveSearch(data);
};
